// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__38w6M","form":"styles_form__3CUDJ"};